// extracted by mini-css-extract-plugin
export default {"title":"SimpleHero__title-WWRU","hero":"SimpleHero__hero-Vgo_","subtitle":"SimpleHero__subtitle-CEK2"};